import { Navigate, useParams, useSearchParams } from 'react-router-dom';

type LanguageRedirectProps = {
    urlLanguage: string;
};

/**
 * Redirects the legacy /en and /de prefixes to the bare path, carrying the
 * language as `?lng=`.
 *
 * Examples:
 * - /en/customers -> /customers?lng=en
 * - /de -> /?lng=de
 *
 * The language itself is not switched — it follows the user's stored
 * preference, which is set by the server on getMe.
 */
export function LanguageRedirect({ urlLanguage }: LanguageRedirectProps) {
    const { '*': path } = useParams();
    const [searchParams] = useSearchParams();

    const search = new URLSearchParams(searchParams);
    search.set('lng', urlLanguage);

    return <Navigate to={{ pathname: `/${path ?? ''}`, search: search.toString() }} replace />;
}
